export function splitEnumToDisplayCase(str: string) {
    return str
        .split("_") // split on underscores
        .map((word, i) => {
            // capitalize first letter, lowercase the rest
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" "); // join with spaces
}